import React from 'react';
import cn from 'clsx';
import Banner from '@v2/shared/components/Banner';
import { Banner as BannerType } from '@v2/shared/lib/types';

type Props = {
  banners: BannerType[];
};

export default function TopBanners({ banners }: Props) {
  return (
    <div className="grid grid-cols-12 gap-y-5 md:gap-6 xl:gap-8 mb-12 lg:mb-14">
      <div className="col-span-12 xl:col-span-7 2xl:col-span-8">
        {banners[0] && (
          <Banner
            banner={banners[0]}
            wrapperClassName="h-40 md:h-72 lg:h-96 rounded-lg lg:rounded-xl block overflow-hidden"
            imageClassName="h-full w-full object-cover object-left"
          />
        )}
      </div>
      <div
        className={cn(
          'grid',
          'grid-cols-1 md:grid-cols-2 xl:grid-cols-1',
          'col-span-12 xl:col-span-5 2xl:col-span-4',
          'gap-x-8 md:gap-x-6 gap-y-5 lg:gap-y-8'
        )}
      >
        {banners[1] && (
          <Banner
            banner={banners[1]}
            wrapperClassName="h-32 lg:h-44 rounded-lg lg:rounded-xl block overflow-hidden"
            imageClassName="h-full w-full object-cover object-center"
          />
        )}
        {banners[2] && (
          <Banner
            banner={banners[2]}
            wrapperClassName="h-32 lg:h-44 rounded-lg lg:rounded-xl block overflow-hidden"
            imageClassName="h-full w-full object-cover object-center"
          />
        )}
      </div>
    </div>
  );
}
